/* Code for trapping focus inside modal
https://gist.github.com/myogeshchavan97/d50d42aa9205573b811587d57c2e58a6 */

export default function trapFocus () {
  // add all the elements inside modal which you want to make focusable
  const focusableElements = '[tabindex]:not([tabindex="-1"])'
  const modal = document.getElementById('popup-modal') // select the modal by it's id

  const firstFocusableElement = document.getElementById('popup-close') // get first element to be focused inside modal
  const focusableContent = modal.querySelectorAll(focusableElements)
  const lastFocusableElement = focusableContent[focusableContent.length - 1] // get last element to be focused inside modal

  document.addEventListener('keydown', (e) => {
    const isTabPressed = e.key === 'Tab' || e.key === 9

    if (!isTabPressed) return

    if (e.shiftKey) { // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus() // add focus for the last focusable element
        e.preventDefault()
      }
    } else { // if tab key is pressed
      if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus() // add focus for the first focusable element
        e.preventDefault()
      }
    }
  })
}
